import Dashboard from "../components/Simulation/Dashboard";
import AiAssistant from "../views/AiAssistant";
import BilanHydrique from "../components/Simulation/BilanHydrique";
import Fields from "../views/Field";
import Sensors from "../views/Sensors";
import SatelliteImages from "../views/SatelliteImages";
import MySimulations from "../components/Simulation/MySimulations";
import Calendar from "../views/Calendar";
import AllNotifications from "../views/AllNotifications";
import Weather from "../views/Weather";
import EditSensorByAdmin from "../views/EditSensorByAdmin";
import AllRecommendations from "../views/AllRecommendations";

import Overview from "../views/Overview";
import Reports from "../views/Reports";
import UserProfileLite from "../views/UserProfileLite";
import AddField from "../views/AddField";
import AdminBoard from "../admin/AdminBoard";
import SensorsManagement from "../admin/SensorsManagement";
import AddSensorByAdmin from "../admin/AddSensor";
import SensorHistory from "../views/SensorHistory";
import SensorSettings from "../views/SensorSettings";
import AddSensor from "../views/AddSensor";
import AddSupplier from "../supplier/AddSupplier";
import AllSuppliers from "../admin/AllSuppliers";
import AddUser from "../admin/AddUser";
import FieldsManagement from "../admin/FieldsManagement";
import CalculSimulation from "../admin/CalculSimulation";
import CommandeManagement from "../admin/CommandeManagement";
import AddEquipmentByAdmin from "../admin/AddEquipment";
import Configuration from "../admin/Configuration";
import EditUserDetail from "../admin/EditUserDetail";
import ConfigurationCities from "../admin/ConfigurationCities";
import ConfigCitiesWeather from "../admin/ConfigCitiesWeather";
import ConfigurationCrops from "../admin/ConfigurationCrops";
import ConfigurationCropsVariety from "../admin/ConfigurationCropsVariety";
import ConfigurationSoils from "../admin/ConfigurationSoils";
import ConfigurationIrrigation from "../admin/ConfigurationIrrigation";
import Graph from "../views/Graph";

import SatelliteManagement from "../admin/SatelliteManagement";
import FieldSatelliteImages from "../admin/FieldSatelliteImages";
import RapportHebdomadaire from "../views/RapportHebdomadaire";

import AddFram from "../views/AddFram";
import SoilInfo from "../views/SoilInfo";
import AddCropInfo from "../views/AddCropInfo";
import AddIrrigation from "../views/AddIrrigation";
import FarmList from "../admin/FarmsList";
import FieldList from "../admin/FieldsList";
import SensorList from "../admin/SensorsList";
import CropDetails from "../views/CropDetails";
import OrdersManagement from "../admin/OrdersManagement";
import Suiviirrigation from "../admin/Suivi_irrigation";

import DashboardSupplier from "../supplier/DashboardSupplier";
import Field from "../views/Field";
import UsersManagement from "../supplier/UsersManagement";
import SupplierSensors from "../supplier/SupplierSensors";
import WizardWrapper from "../components/wrappers/WizardWrappers";
import FieldSoilFormWrapper from "../components/wrappers/FieldSoilFormWrapper";
import AddCropInfoWrapper from "../components/wrappers/AddCropInfoWrapper";
import AddIrrigationWrapper from "../components/wrappers/AddIrrigationWrapper";
import AddFieldWrapper from "../components/wrappers/AddFieldWrapper";
import AddFarmWrapper from "../components/wrappers/AddFarmWrapper";
import CompanyProfile from "../supplier/CompanyProfile";
import AddUserBySupplier from "../supplier/AddUserBySupplier";
import GestionReclamations from "../admin/GestionReclamations";
import FaqReact from "../admin/faqVue";
import SupportCenter from "../admin/SupportCenter";
import DeletedUsers from "../admin/Deleted_users";
import SensorInstallationManager from "../views/SensorInstallationManager";
import FieldHistoryPage from "../views/field-history";
import UserManagement from "../views/SubUserMangment";
import FieldHistory from "../views/field-history-season";
import CalculationDetails from "../views/CalculationDetails";
import ClimateHistory from "../views/ClimateHistory";
import AdminOverview from "../admin/AdminOverview";
import AdminAiUsage from "../admin/AdminAiUsage";
const protectedRoutes = [
  { name: "AI usage and budget", path: "/admin/ai-usage", element: <AdminAiUsage />, roles: ["ROLE_ADMIN"] },
  {
    name: "Admin Overview",
    path: "/admin/overview",
    element: <AdminOverview />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Dashboard",
    path: "/dashboard",
    element: <Dashboard />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "guest"],
  },
  {
    name: "Dashboard Supplier",
    path: "/Dashboard-supplier",
    element: <DashboardSupplier />,
    roles: ["ROLE_SUPPLIER"],
  },
  {
    name: "Field Details",
    path: "/Fields/:userId/:fieldUid",
    element: <Field />,
    roles: ["ROLE_SUPPLIER"],
  },
  {
    name: "Users Management",
    path: "/supplier/users",
    element: <UsersManagement />,
    roles: ["ROLE_SUPPLIER"],
  },
  {
    name: "My Company",
    path: "/my-company",
    element: <CompanyProfile />,
    roles: ["ROLE_SUPPLIER"],
  },
  {
    name: "Add user",
    path: "/supplier/add-user",
    element: <AddUserBySupplier />,
    roles: ["ROLE_SUPPLIER"],
  },
  {
    name: "singleCrop",
    path: "/crop/:id",
    element: <CropDetails />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "guest"],
  },
  {
    name: "RapportHebdomadaire",
    path: "/rapport-hebdomadaire/:fieldId",
    element: <RapportHebdomadaire />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Fields",
    path: "/fields/:id",
    element: <Fields />,
    roles: ["ROLE_USER", "ROLE_ADMIN"],
  },
  {
    name: "Sensors",
    path: "/sensors/:id",
    element: <Sensors />,
    roles: ["ROLE_ADMIN", "guest", "ROLE_USER", "ROLE_SUPPLIER"],
  },

  {
    name: "Sensors all",
    path: "/sensors",
    element: <Sensors />,
    roles: ["ROLE_ADMIN", "guest", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "Sensors supplier",
    path: "/supplier/sensors",
    element: <SupplierSensors />,

    roles: ["ROLE_ADMIN", "guest", "ROLE_USER", "ROLE_SUPPLIER"],
  },

  // {
  //   name: 'My Simulations',
  //   path: '/simulations',
  //   element: <Simulations />,
  //   roles: ['ROLE_ADMIN',"ROLE_USER"]
  // },
  {
    name: "Calendar",
    path: "/calendar",
    element: <Calendar />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "Weather Forecast",
    path: "/weather",
    element: <Weather />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "AllRecommendations",
    path: "/recommendations/:id",
    element: <AllRecommendations />,
    roles: ["ROLE_ADMIN", "ROLE_USER"],
  },
  {
    name: "AddSensor",
    path: "/AddSensor",

    element: <AddSensor />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "Graph",
    path: "/Graphs/:uid",

    element: <Graph />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "GraphLegacy",
    path: "/Graphs",

    element: <Graph />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "edit-sensor",
    path: "/admin/edit-sensor/:id",
    element: <EditSensorByAdmin />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Overview",
    path: "/overview",
    element: <Overview />,
    roles: ["ROLE_ADMIN"],
  },

  // {
  //   name: "recommendations",
  //   path: "/admin/user/:uid/recommendations",
  //   element: <Recommendations />,
  //   roles: ["ROLE_ADMIN"],
  // },

  {
    name: "admin Board",
    path: "/admin/users",
    element: <AdminBoard />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "deleted-users",
    path: "/admin/deleted-users",
    element: <DeletedUsers />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "user detail",
    path: "/admin/user/:uid",
    element: <EditUserDetail />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "field-history",
    path: "field-history/:uid",
    element: <FieldHistoryPage />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "user farm list ",
    path: "/admin/user/:uid/farms",
    element: <FarmList />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "user field list ",
    path: "/admin/user/:uid/fields",
    element: <FieldList />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "user sensor list ",
    path: "/admin/user/:uid/sensors",
    element: <SensorList />,
    roles: ["ROLE_ADMIN"],
  },

  {
    name: "admin Board",
    path: "/admin/sensors",

    element: <SensorsManagement />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "add-sensor",
    path: "/admin/add-sensor",
    element: <AddSensorByAdmin />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "sensor-history",
    path: "/my-history/:id",

    element: <SensorHistory />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "sensor-history",
    path: "/my-history",
    element: <SensorHistory />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "supplier",
    path: "/Supplier",
    element: <AddSupplier />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "all supplier",
    path: "/admin/all-suppliers",
    element: <AllSuppliers />,
    roles: ["ROLE_ADMIN", "ROLE_SUPPLIER"],
  },
  {
    name: "Satellite images by admin",
    path: "/admin/satellite-images",
    element: <SatelliteManagement />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Satellite images by admin by field",
    path: "/admin/satellite-images/:fieldId",
    element: <FieldSatelliteImages />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "add user",
    path: "/admin/add-user",
    element: <AddUser />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "fields",
    path: "/admin/fields",
    element: <FieldsManagement />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "calcul simulation",
    path: "/admin/calcul-fields/:fieldId",
    element: <CalculSimulation />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Commande Management",
    path: "/admin/commande",

    element: <CommandeManagement />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Suivi irrigation",
    path: "/admin/Suivi_irrigation",
    element: <Suiviirrigation />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Orders Management",
    path: "/admin/orders",
    element: <OrdersManagement />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "AddEquipmentByAdmin",
    path: "/admin/add-equipment",

    element: <AddEquipmentByAdmin />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Configuration",
    path: "/admin/configuration",

    element: <Configuration />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Cities configuration",
    path: "/admin/configuration/cities",
    element: <ConfigurationCities />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Support Center",
    path: "/admin/support-center",
    element: <SupportCenter />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "FAQ",
    path: "/admin/FAQ",
    element: <FaqReact />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "configuration weather",
    path: "/admin/configuration/cities/weather/:id",

    element: <ConfigCitiesWeather />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "configuration crop",
    path: "/admin/configuration/crops",
    element: <ConfigurationCrops />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "configuration cropsVariety",
    path: "/admin/configuration/cropsVariety",
    element: <ConfigurationCropsVariety />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "configuration soil",
    path: "/admin/configuration/soils",

    element: <ConfigurationSoils />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Configuration Irrigation",
    path: "/admin/configuration/irrigations",
    element: <ConfigurationIrrigation />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "SensorInstallationManager",
    path: "/admin/configuration/SensorInstallationManager",
    element: <SensorInstallationManager />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "reclamations",
    path: "/admin/reclamations",
    element: <GestionReclamations />,
    roles: ["ROLE_ADMIN"],
  },
  {
    name: "Sensor Settings",
    path: "/sensor-settings",

    element: <SensorSettings />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "Add Field",
    path: "/AddField",
    element: <AddField />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "BilanHydrique",
    path: "/Bilan",
    element: <BilanHydrique />,
    roles: ["ROLE_ADMIN", "ROLE_USER"],
  },
  {
    name: "UserProfileLite",
    path: "/user-profile",
    element: <UserProfileLite />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "Reports",
    path: "/my-reports",
    element: <Reports />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "Simulations",
    path: "/Simulations/:idSimulation",

    element: <MySimulations />,
    roles: ["ROLE_ADMIN", "ROLE_USER"],
  },
  {
    name: "AllNotifications",
    path: "/notifications",
    element: <AllNotifications />,
    roles: ["ROLE_ADMIN", "ROLE_USER"],
  },
  {
    name: "SatelliteImages",
    path: "/satellite-images",

    element: <SatelliteImages />,
    roles: ["ROLE_ADMIN", "ROLE_USER"],
  },
  {
    name: "add-farm",
    path: "/add-farm",
    element: (
      <WizardWrapper currentStep={0}>
        <AddFarmWrapper />
      </WizardWrapper>
    ),
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "add-field",
    path: "/add-field",
    element: (
      <WizardWrapper currentStep={1}>
        <AddFieldWrapper />
      </WizardWrapper>
    ),
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "add soil Info",
    path: "/add-soil-info",
    element: (
      <WizardWrapper currentStep={2}>
        <FieldSoilFormWrapper />
      </WizardWrapper>
    ),
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "add crop Info",
    path: "/add-crop-info",
    element: (
      <WizardWrapper currentStep={3}>
        <AddCropInfoWrapper />
      </WizardWrapper>
    ),
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    name: "user mangment for normal user",
    path: "/sub-users-management",
    element: <UserManagement />,
    roles: ["ROLE_USER", "ROLE_ADMIN"],
  },
  {
    name: "addIrrigation",
    path: "/add-irrigation",
    element: (
      <WizardWrapper currentStep={4}>
        <AddIrrigationWrapper />
      </WizardWrapper>
    ),
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    path: "/field-history-season/:uid",
    element: <FieldHistory />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    path: "/calculations/:cropId",
    element: <CalculationDetails />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
  {
    path: "/climatehistory",
    element: <ClimateHistory />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },

  {
    name: "AI Assistant",
    path: "/assistant",
    element: <AiAssistant />,
    roles: ["ROLE_ADMIN", "ROLE_USER", "ROLE_SUPPLIER"],
  },
];

export default protectedRoutes;
